<template>
  <form @submit.prevent="abapayway()">
    <input v-model="forminfo.req_time" />
    <input v-model="forminfo.merchant_id" />
    <input v-model="forminfo.tran_id" />
    <input v-model="forminfo.amount" />
    <input v-model="forminfo.payment_option" />
    <input v-model="forminfo.hash" />
    <input type="submit" value="submit" />
  </form>
  <button @click="testvueapi()">Checkout Now</button>
  <div v-html="responsedata">
    
  </div>
</template>

<script>

  import axios from 'axios';
  //import { $http } from "vue-resource";

  export default {
  name: "App",
  data(){
    return {
      paystatus : 0,
      responsedata: null,
      forminfo : {
        req_time: "202220222022202209090707105516",
        merchant_id: "bookmefly",
        tran_id:"2209071662522916",
        amount:"10.00",
        payment_option:"abapay",
        hash:"rWBv6VWKEckI2YNOtUE4SnvrSkrXvBSIWrDh4kc3fFbAJonsJALl4hsiv4fuW7FzxBBxx/T8O/wp8f5bs9fR7w==",
      }
    };
  },
  components: {
    //api
  },
  methods : {
    testvueapi() {
      const jsonform = JSON.stringify({ cid: "CSDEIP",cidkey: "168mb8VlEP",reqtype: "CSDIEP2022" });
      // fetch('http://api.csdcambodia.com/api/csdiep/',{
      //   method : 'post',
      //   headers : {
      //     'Content-Type': 'application/json; charset=UTF-8',
      //   },
      //   body: jsonform

      // })
      // .then((res) => console.log(res))
      // .then((err) => console('err:' + err));

      const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: jsonform
    };
    fetch("http://api.csdcambodia.com/api/csdiep/", requestOptions)
      .then(response => {
        console.log(response);
        //console.log(response.json());
      })
      .then(data => console.log(data));
      
    },
    testapi() {
      const jsonform = JSON.stringify({ cid: "CSDEIP",cidkey: "168mb8VlEP",reqtype: "CSDIEP2022" });

      const instance = axios.create({
        //baseURL: 'http://api.csdcambodia.com',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      console.log(jsonform);

      const response = instance.post("http://csdcambodia.com/api/csdiep/", jsonform)
        .then(res => {
          console.log(res.data);
          this.responsedata = res.data;
          //this.msg = "Post has been created";
          //this.classAlert = "success";
          //this.posts.unshift(res.data);
          //this.cancel(true);
        })
        .catch(err => {
          console.log("error");
          console.log(err);
          this.responsedata = "error: " + err.response;
          //this.msg = err.response.data.messages.error;
          //this.classAlert = "danger";
        });

      console.log(response);

    },
    abapayway() {
      const form = new FormData();
      form.append("req_time", this.req_time);
      form.append("merchant_id", this.merchant_id);
      form.append("tran_id", this.tran_id);
      form.append("firstname", "");
      form.append("lastname", "");
      form.append("email", "");
      form.append("phone", "");
      form.append("amount", this.amount);
      form.append("type", "purchase");
      form.append("payment_option", this.payment_option);
      form.append("item", "");
      form.append("currency", "USD");
      form.append("continue_success_url", "bookmefly.com");
      form.append("hash", this.hash);

      console.log(this.forminfo);
      
    // const requestOptions = {
    //   method: "POST",
    //   headers: { "Content-Type": "multipart/form-data" },
    //   body: form
    // };
    // fetch("https://checkout-sandbox.payway.com.kh/api/payment-gateway/v1/payments/purchase", requestOptions)
    //   .then(response => {
    //     console.log(response);
    //     //console.log(response.json());
    //   })
    //   .then(data => console.log(data));
    var myHeaders = new Headers();
    myHeaders.append("Content-Type","multipart/form-data");
    myHeaders.append("Cookie", "i18n_redirected=en");

    var formdata = new FormData();
    formdata.append("req_time", "202220222022202209090707105516");
    formdata.append("merchant_id", "bookmefly");
    formdata.append("tran_id", "2209071662522916");
    formdata.append("amount", "10.00");
    formdata.append("payment_option", "cards");
    formdata.append("hash", "rWBv6VWKEckI2YNOtUE4SnvrSkrXvBSIWrDh4kc3fFbAJonsJALl4hsiv4fuW7FzxBBxx/T8O/wp8f5bs9fR7w==");

    // var requestOptions = {
    //   method: 'POST',
    //   headers: myHeaders,
    //   body: formdata,
    //   redirect: 'follow'
    // };

    // fetch("/api/payment-gateway/v1/payments/purchase/", requestOptions)
    //   .then(response => this.responsedata = response)
    //   .then(result => this.responsedata = result)
    //   .catch(error => console.log('error', error));
      
      //.then(result => this.responsedata = result)
      

      axios.post("https://checkout-sandbox.payway.com.kh/api/payment-gateway/v1/payments/purchase/", formdata,{
          headers: {
            "Content-Type": "multipart/form-data;"
          }
        })
        .then(res => {
          console.log(res);
          this.responsedata = res.data;
          //this.msg = "Post has been created";
          //this.classAlert = "success";
          //this.posts.unshift(res.data);
          //this.cancel(true);
        })
        .catch(err => {
          console.log("error");
          console.log(err);
          this.responsedata = "error: " + err.response;
          //this.msg = err.response.data.messages.error;
          //this.classAlert = "danger";
        });
      
     
      


    }
  }
  
};

</script>
